import { render, staticRenderFns } from "./UsersEvaluated.vue?vue&type=template&id=49b9353b&"
import script from "./UsersEvaluated.vue?vue&type=script&lang=js&"
export * from "./UsersEvaluated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports